import { useState, type FormEvent } from "react";
import { api, type User } from "../lib/api";

export function LoginPage({ onLogin }: { onLogin: (user: User) => void }) {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault(); setError(""); setBusy(true);
    const form = new FormData(event.currentTarget);
    try {
      await api("/api/auth/login", { method: "POST", body: JSON.stringify({ username: form.get("username"), password: form.get("password") }) });
      const result = await api<{ user: User }>("/api/auth/me"); onLogin(result.user);
    } catch (e) { setError(e instanceof Error ? e.message : "로그인 실패"); } finally { setBusy(false); }
  };
  return <main className="login-shell">
    <section className="login-card">
      <div className="brand-mark"><i className="bi bi-camera-video-fill" /></div>
      <p className="eyebrow">네트워크 영상 녹화기</p><h1>NVR</h1>
      <form onSubmit={submit} className="mt-4">
        <label className="form-label">사용자</label><input className="form-control mb-3" name="username" autoComplete="username" required autoFocus />
        <label className="form-label">비밀번호</label><input className="form-control mb-3" type="password" name="password" autoComplete="current-password" required />
        {error && <div className="alert alert-danger py-2">{error}</div>}
        <button className="btn btn-primary w-100" disabled={busy}>{busy ? "확인 중…" : "로그인"}</button>
      </form>
      <p className="login-warning"><i className="bi bi-shield-lock" />허가된 인가자 이외의 접근은 관련 법령에 저촉될 수 있습니다.</p>
    </section>
  </main>;
}
